import { getReferenceId } from '@quromedical/fhir-common';
import {
  ClaimResponseGetAllParams,
  ClaimResponseModel,
  ClaimResponseModelGetAllResponse,
  ClaimResponseModelGetResponse,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class ClaimResponseApi {
  public async getAll(
    params: ClaimResponseGetAllParams = {}
  ): Promise<ClaimResponseModelGetAllResponse> {
    const result = await trpc.client.claimResponse.getAll.query({ ...params });

    return result;
  }

  public async reverseClaim(
    claimResponse: ClaimResponseModel
  ): Promise<ClaimResponseModelGetResponse | undefined> {
    const claimId = getReferenceId(claimResponse.claim) || '';
    const claim = await trpc.client.claim.getById.query({ id: claimId });

    if (!claim.invoiceNumber) {
      return undefined;
    }

    const result = await trpc.client.claimResponse.reverse.mutate({
      invoiceNumber: claim.invoiceNumber,
    });

    return result;
  }
}
